import React, { Fragment, FunctionComponent } from "react";

import { Caption, Divider, FontWeight, JustifyContent, Layout, LocalizationProvider, SpacingSize, Text, VerticalDivider, WhiteSpace } from "@multiweb/reactComponents";
import { bemClassNames } from "@multiweb/reactUtils";
import { LOC_BASIC_CONDITION, LOC_TRANSITION_NAME } from "../../../locKeys";
import { ActivityTransition } from "../../../types";

type ActivityTransitionsListProps = {
    readonly headerLocKey: string;
    readonly leadingLocKey: string;
    readonly fallbackTextLocKey: string;
    readonly activityTransitions: readonly ActivityTransition[];
};

const classNames = bemClassNames("activity-transitions-list");
const frameClassName = classNames();
const headerContainer = classNames("header-container");
const contentContainer = classNames("content-container");
const contentContainerItems = classNames("content-container-items");
const transitionNameCell = classNames("transition-name-cell");
const basicConditionCell = classNames("basic-condition-cell");
const leadingCell = classNames("leading-cell");
const noTransitionContainer = classNames("no-transition-container");

export const ActivityTransitionsList: FunctionComponent<ActivityTransitionsListProps> = ({ activityTransitions, headerLocKey, leadingLocKey, fallbackTextLocKey }) => (
    <div className={frameClassName}>
        <Fragment>
            <Layout spacingSizeVertical={SpacingSize.s} justifyContent={JustifyContent.center}>
                <LocalizationProvider locKey={headerLocKey}>
                    {({ text }) => (
                        <Text value={text} fontWeight={FontWeight.bold} />
                    )}
                </LocalizationProvider>
            </Layout>
            <Divider />
            {activityTransitions.length > 0 ?
                <Fragment>
                    <div className={headerContainer}>
                        <div className={transitionNameCell}>
                            <Caption locKey={LOC_TRANSITION_NAME} />
                        </div>
                        <VerticalDivider />
                        <div className={basicConditionCell}>
                            <Caption locKey={LOC_BASIC_CONDITION} />
                        </div>
                        <VerticalDivider />
                        <div className={leadingCell}>
                            <Caption locKey={leadingLocKey} />
                        </div>
                    </div>
                    <Divider />
                    <div className={contentContainer}>
                        {activityTransitions.map(({ otherActivityName, transitionName, transitionCondition }, index) => (
                            <div key={`${otherActivityName}${index}`}>
                                <div className={contentContainerItems}>
                                    <div className={transitionNameCell}>
                                        <Text value={transitionName} title={transitionName} whiteSpace={WhiteSpace.nowrap} ellipsis />
                                    </div>
                                    <VerticalDivider />
                                    <div className={basicConditionCell}>
                                        <Text value={transitionCondition} title={transitionCondition} whiteSpace={WhiteSpace.nowrap} ellipsis />
                                    </div>
                                    <VerticalDivider />
                                    <div className={leadingCell}>
                                        <Text fontWeight={FontWeight.bold} value={otherActivityName} title={otherActivityName} whiteSpace={WhiteSpace.nowrap} ellipsis />
                                    </div>
                                </div>
                                <Divider />
                            </div>
                        ))}
                    </div>
                </Fragment> :
                <div className={noTransitionContainer}>
                    <LocalizationProvider locKey={fallbackTextLocKey} />
                </div>}
        </Fragment>
    </div>
);
